import { render, staticRenderFns } from "./FloatingChatIcon.vue?vue&type=template&id=f837c036"
import script from "./FloatingChatIcon.vue?vue&type=script&lang=js"
export * from "./FloatingChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports